import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../store/AuthContext';
import { getDashboardRoute } from '../../utils/roleHelpers';
import { Spinner } from '../../components/ui/index';

export default function RedirectDashboard() {
  const navigate = useNavigate();
  const { user, loadProfile } = useAuth();

  useEffect(() => {
    const go = async () => {
      const profile = user || await loadProfile();
      if (profile) navigate(getDashboardRoute(profile.type), { replace: true });
      else navigate('/', { replace: true });
    };
    go();
  }, [user, loadProfile, navigate]);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <Spinner size={36} />
    </div>
  );
}
